import React, { useState, useEffect }  from 'react'
import firebase from '../util/firebase.js';
import { useAuth } from "../util/auth.js";
// import { useDocument } from 'react-firebase-hooks/firestore';
import { useRouter } from "../util/router.js";
import { BsBookmarkFill } from "react-icons/bs"
import { BsBookmark } from "react-icons/bs"
import './BookmarkCoffee.scss'

function SaveCoffee(props) {
  const auth = useAuth();
  const router = useRouter();
  console.log("BookmarkCoffee has rendered");

    const { coffee: {
      coffeeName,
      coffeeProductUrl,
      coffeeCountry,
      coffeeRegion,
      growingRegion,
      coffeeCompany,
      tastingNotes,
      coffeeFlavor,
      coffeeCultivar,
      coffeeType,
      coffeeProcess,
      coffeePrice,
      coffeeBagSize,
      roasterLocation,
      coffeeReviewAvg,
      coffeeRatingTotalAdj,
      coffeeReviewsNumTotal,
      coffeeId,
      coffeeImgUrl,
      bookmarked,
      }} = props;      
      
      // const bookmarkRef = firebase.firestore().doc(`/coffee/${coffeeId}/saved/${firebase.auth().currentUser.uid}_${coffeeId}`);
      // const [bookmarkDoc] = useDocument(bookmarkRef);      
      
      const [saved, setSaved] = useState(bookmarked);        
      const [bookmarkAdd, setBookmarkAdd] = useState(null);        
      const [bookmarkDelete, setBookmarkDelete] = useState(null);        
      
      useEffect(() => {
        const getSavedValue = async () => {
          //only perform if auth.user object is true (user logged in) - this line also prevents refresh from working
          if (firebase.auth().currentUser && !saved) {
            const savedRef = firebase.firestore().doc(`/coffee/${coffeeId}/saved/${firebase.auth().currentUser.uid}_${coffeeId}`);
              await savedRef.onSnapshot(function(doc) {
              if (doc.exists) {
                setSaved(true)
                console.log("Data pull on getSavedValue in SaveCoffee has run");
              } 
             })}
          };
         getSavedValue();
        // eslint-disable-next-line
      }, []);

    const addBookmark = async (index) => {
      //push to signup page if not logged in
      if (!auth.user) {
        router.push("/auth/signup")

        } else {

        const saveRef = firebase.firestore().collection('coffee').doc(coffeeId).collection('saved');
        setSaved(true);
        setBookmarkAdd(true);
        await saveRef.doc(`${auth.user.id}_${coffeeId}`).set({

          coffeeId: coffeeId,
          coffeeName: coffeeName,
          coffeeProductUrl: coffeeProductUrl,
          coffeeCountry: coffeeCountry,
          coffeeRegion: coffeeRegion,
          growingRegion: growingRegion,
          coffeeCompany: coffeeCompany,
          tastingNotes: tastingNotes,
          coffeeFlavor: coffeeFlavor,
          coffeeCultivar: coffeeCultivar,
          coffeeType: coffeeType,
          coffeeProcess: coffeeProcess,
          coffeePrice: parseFloat(coffeePrice),
          coffeeBagSize: parseFloat(coffeeBagSize),
          roasterLocation: roasterLocation,
          coffeeRatingTotalAdj: coffeeRatingTotalAdj,
          coffeeReviewsNumTotal: coffeeReviewsNumTotal,
          coffeeReviewAvg: coffeeReviewAvg,
          coffeeImgUrl: coffeeImgUrl,
          createdTime: firebase.firestore.FieldValue.serverTimestamp(),
          uid: auth.user.id,
          bookmarked: true,
        })};
        console.log("addBookmark has executed in saveCoffee")
        }        

        const deleteBookmark = async (index) => {
          setSaved(null);
          setBookmarkDelete(true);
          const saveRef = firebase.firestore().collection('coffee').doc(coffeeId).collection('saved');
          await saveRef.doc(`${auth.user.id}_${coffeeId}`).delete();
          console.log("deleteBookmark has executed in SaveCoffee")
        }

    return  saved ? (

        <div className={bookmarkAdd ? "animate-add save-bookmark" : "save-bookmark"}>
          <button type="radio" onClick={deleteBookmark}>
              <BsBookmarkFill color="#606c38" size={25} title="Remove Bookmark" />
          </button>
          </div>
    ) : (
      <div className={bookmarkDelete ? "animate-delete save-bookmark" : "save-bookmark"}>
      <button type="radio" onClick={addBookmark}>
          <BsBookmark color="#606c38" size={25} title="Add Bookmark" />
      </button>
      </div>
      )
}

export default SaveCoffee

// {/* <div className="save-bookmark mt-2" style={{ display: 'inline' }}>
// <button
//   type="radio"
//   onClick={() => (saved ? deleteSavedCoffee() : updateSavedCoffee())}
// >
//   <span className="bookmark">
//     {saved ? 
//       <BsBookmarkFill color="#606c38" size={25} title="Bookmarked" />
//       :
//       <BsBookmark color="#7e8a97" size={25} title="Bookmark" />}
//   </span>
// </button> */}

// Old method using querysnapshot to pull
// const getSavedValue = () => {
//   //only perform if auth.user object is true (user logged in) - this line also prevents refresh from working
//   if (firebase.auth().currentUser) {
//     const savedRef = firebase.firestore().doc(`/coffee/${coffeeId}/saved/${firebase.auth().currentUser.uid}_${coffeeId}`);
//      savedRef.onSnapshot((doc) => {
//       if (doc.exists) {
//         setSaved(true)
//         // setButtonFill("success")
//         // setButtonText("Saved")
//         console.log("Data pull on getSavedValue in SaveCoffee has run");
//       } 
//     }) }
//   }

// {/* onClick={saved ? deleteSavedCoffee() : updateSavedCoffee()} */}

// {/* <div className="mt-2">
// <Button 
//   variant={buttonFill}
//   size="sm"
//   onClick={() => (saved ? deleteSavedCoffee() : updateSavedCoffee())}
// >
//   {buttonText}
// </Button> */}

